const MutationTypes = {
  SET_LAST_VIEWED_RECORD_ID: "SET_LAST_VIEWED_RECORD_ID",
  CLEAR_LAST_VIEWED_RECORD_ID: "CLEAR_LAST_VIEWED_RECORD_ID",
  SET_PAGINATION_STATE: "SET_PAGINATION_STATE",
  CLEAR_PAGINATION_STATE: "CLEAR_PAGINATION_STATE",
};

const initialState = {
  lastViewedRecordIds: {}, // Key: entityType, Value: recordId
  paginationStates: {}, // Key: viewId, Value: paginationState object
};

const state = { ...initialState };

const mutations = {
  [MutationTypes.SET_LAST_VIEWED_RECORD_ID](state, { entityType, recordId }) {
    state.lastViewedRecordIds = {
      ...state.lastViewedRecordIds,
      [entityType]: recordId,
    };
  },

  [MutationTypes.CLEAR_LAST_VIEWED_RECORD_ID](state, entityType) {
    const newState = { ...state.lastViewedRecordIds };
    delete newState[entityType];
    state.lastViewedRecordIds = newState;
  },

  [MutationTypes.SET_PAGINATION_STATE](state, { viewId, paginationState }) {
    state.paginationStates = {
      ...state.paginationStates,
      [viewId]: paginationState,
    };
  },

  [MutationTypes.CLEAR_PAGINATION_STATE](state, viewId) {
    const newState = { ...state.paginationStates };
    delete newState[viewId];
    state.paginationStates = newState;
  },
};

const actions = {
  setLastViewedRecordId({ commit }, { entityType, recordId }) {
    commit(MutationTypes.SET_LAST_VIEWED_RECORD_ID, { entityType, recordId });
  },

  clearLastViewedRecordId({ commit }, entityType) {
    commit(MutationTypes.CLEAR_LAST_VIEWED_RECORD_ID, entityType);
  },

  setPaginationState({ commit }, { viewId, paginationState }) {
    commit(MutationTypes.SET_PAGINATION_STATE, { viewId, paginationState });
  },

  clearPaginationState({ commit }, viewId) {
    commit(MutationTypes.CLEAR_PAGINATION_STATE, viewId);
  },
};

const getters = {
  getLastViewedRecordId: (state) => (entityType) => {
    return state.lastViewedRecordIds[entityType] || null;
  },

  getPaginationState: (state) => (viewId) => {
    return state.paginationStates[viewId] || null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
